import React from 'react';
import { useDispatch } from 'react-redux';
import { OriCheckbox, OriSelect } from 'src/components/Antd';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getGridSetting,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onGridSettingChange,
} from '../slice';
import css from './css.module.less';
const Option = OriSelect.Option;

const GridSetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const d = useDispatch();
  const { data, themeList } = props;
  const {
    buttonThemeUuid,
    displayProductDescription,
    displayRRP,
    display2ndCurrencyPrice,
    displayProductReview,
    displayProductPromotionTag,
  } = data;
  const handleOnThemeChange = (buttonThemeUuid) => {
    d(onGridSettingChange({ buttonThemeUuid }));
  };
  return (
    <React.Fragment>
      <Section size='small' bottomBorder>
        <ItemWrapper
          size='small'
          title={`“${getI18n('salesChannelContent.index.addtoCart')}” ${getI18n(
            'salesChannelContent.index.buttonTheme',
          )}`}>
          <OriSelect
            value={buttonThemeUuid || null}
            size='large'
            onChange={handleOnThemeChange}>
            <Option value={null}>{getI18n('general.status.none')}</Option>
            {(themeList || []).map((i) => {
              const { uuid, name } = i;
              return (
                <Option value={uuid} key={uuid}>
                  {name}
                </Option>
              );
            })}
          </OriSelect>
        </ItemWrapper>
      </Section>
      <Section size='small' bottomBorder>
        <OriCheckbox
          className={css.checkboxContainer}
          checked={displayProductDescription}
          onChange={(e) => {
            const v = e.target.checked;
            d(onGridSettingChange({ displayProductDescription: v }));
          }}>
          {getI18n('salesChannelContent.index.displayproductdescription')}
        </OriCheckbox>
        <OriCheckbox
          className={css.checkboxContainer}
          checked={displayRRP}
          onChange={(e) => {
            const v = e.target.checked;
            d(onGridSettingChange({ displayRRP: v }));
          }}>
          {getI18n('salesChannelContent.index.displayRRP')}
        </OriCheckbox>
        <OriCheckbox
          className={css.checkboxContainer}
          checked={display2ndCurrencyPrice}
          onChange={(e) => {
            const v = e.target.checked;
            d(onGridSettingChange({ display2ndCurrencyPrice: v }));
          }}>
          {getI18n('salesChannelContent.index.displaysecondarycurrencyprice')}
        </OriCheckbox>
        <OriCheckbox
          className={css.checkboxContainer}
          checked={displayProductReview}
          onChange={(e) => {
            const v = e.target.checked;
            d(onGridSettingChange({ displayProductReview: v }));
          }}>
          {getI18n('salesChannelContent.index.displayproductreview')}
        </OriCheckbox>
        <OriCheckbox
          className={css.checkboxLast}
          checked={displayProductPromotionTag}
          onChange={(e) => {
            const v = e.target.checked;
            d(onGridSettingChange({ displayProductPromotionTag: v }));
          }}>
          {getI18n('salesChannelContent.index.displayproductpromotiontag')}
        </OriCheckbox>
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(GridSetting, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.gridSetting,
  getContent: getGridSetting,
  title: getI18nFromGeneral('general.hOCTitle.productGridSetting'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //validation: topLeaderBoardBannerValidation,
  getSubmitStamp,
});
